/**
 * ╔═══════════════════════════════════════════════════════════════════════════╗
 * ║                         BRAND CONFIGURATION                              ║
 * ║           Change these values when forking for a new creator             ║
 * ╠═══════════════════════════════════════════════════════════════════════════╣
 * ║                                                                           ║
 * ║  This is the SINGLE SOURCE OF TRUTH for all brand-specific values        ║
 * ║  in the fan-facing frontend. When forking for a new creator/company,     ║
 * ║  change the values here. index.html must also be updated manually.       ║
 * ║                                                                           ║
 * ╚═══════════════════════════════════════════════════════════════════════════╝
 */

// ============================================================================
// CREATOR IDENTITY
// ============================================================================

/** Creator's display name */
export const CREATOR_NAME = 'Caryn'

/** Brand name (used in titles, headers) */
export const BRAND_NAME = 'cutiecaryn'

/** Site domain (without protocol) */
export const SITE_DOMAIN = 'cutiecaryn.com'

/** Community/fan group name */
export const COMMUNITY_NAME = 'Caryn Army'

/** Product/world name */
export const PRODUCT_NAME = "Caryn's World"

/** Creator's initials (used in signatures) */
export const CREATOR_INITIALS = 'cm'

// ============================================================================
// CONTACT & SOCIAL
// ============================================================================

/** Primary support email */
export const SUPPORT_EMAIL = 'caryn@fansupportdesk.com'

/** Twitter/X handle */
export const TWITTER_HANDLE = 'cutiecarynHQ'

/** Twitter/X URL */
export const TWITTER_URL = 'https://twitter.com/cutiecarynHQ'

// ============================================================================
// PAGE COPY
// ============================================================================

/** Login page header */
export const LOGIN_TITLE = 'cutiecaryn'

/** Login page subtitle */
export const LOGIN_SUBTITLE = 'invite only community'

/** Apply page header */
export const APPLY_TITLE = 'cutiecaryn'

/** Apply page subtitle */
export const APPLY_SUBTITLE = 'Membership Application'

/** Community membership question */
export const COMMUNITY_QUESTION = `Are you an active ${COMMUNITY_NAME} member?`

/** Application confirmation message */
export const CONFIRMATION_MESSAGE = `You're now in line to join ${PRODUCT_NAME}. Please be patient while your application is reviewed. If you'd like it reviewed sooner, you can choose to expedite your application.`

/** Chat bot persona name */
export const CHAT_BOT_NAME = 'Caryn'

// ============================================================================
// WELCOME MESSAGES
// ============================================================================

/** Welcome back message for returning users */
export const WELCOME_BACK_MESSAGE = `Welcome to ${SITE_DOMAIN} this is the last and final stop on the journey in my community. If you are reading this, then you have been personally invited to this ecosystem. I have decided to create my own little world where you can find everything and anything on me. I plan on spending much more time here and eventually make it the only place you can find me. Thank you for following along the journey. Welcome to ${SITE_DOMAIN} 💗`

/** Post-payment welcome message */
export const POST_PAYMENT_WELCOME_MESSAGE = `Welcome to ${SITE_DOMAIN}! I'm so happy you're here. This is your exclusive space to connect with me directly. I can't wait to get to know you better! 💗`

/** Welcome message signature */
export const WELCOME_SIGNATURE = CREATOR_INITIALS

// ============================================================================
// BRAND COLORS (for chat widget and inline styles)
// ============================================================================

export const BRAND_COLORS = {
  primary: '#ec4899',         // pink-500
  primaryDark: '#db2777',     // pink-600
  primaryDarker: '#be185d',   // pink-700
  backgroundLight: '#fce7f3', // pink-100
  backgroundAccent: '#fdf2f8', // pink-50
  inputBorder: '#f9a8d4',     // pink-300
  themeColor: '#ec4899',      // meta theme-color
}
